import React, { PureComponent, Fragment } from 'react'
import FormHelperText from '@material-ui/core/FormHelperText';

import {Radio, RadioGroup, FormControlLabel} from 'components/OptimisedMui'
import PropTypes from 'prop-types'

export class CurrencySelect extends PureComponent {
  static propTypes = {
    currencies: PropTypes.array.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
  }

  render = () => {
    let {currencies, disabled, value, error, helperText, ...props} = this.props
    return (
      <Fragment>
        {error &&
          <FormHelperText error={true}>{helperText}</FormHelperText>
        }
        <RadioGroup {...props} value={`${value}`}>
          {currencies.map(currency =>
            <FormControlLabel value={currency.id} control={<Radio disabled={disabled}/>} label={currency.code} key={currency.code} />
          )}
        </RadioGroup>
      </Fragment>
    )
  }
}